import './styles/tailwind.css';
import './styles/style.css';

import { fetchContentJson, getContent } from './services/content';
import { buildHero } from './components/Hero';
import { buildAbout } from './components/About';
import { buildExperience } from './components/Experience';
import { buildEducation } from './components/Education';
import { buildCertifications } from './components/Certifications';
import { buildSkills } from './components/Skills';
import { buildProjects } from './components/Projects';
import { buildContact } from './components/Contact';
import { buildFooter } from './components/Footer';
import { initNavigation } from './components/Navigation';
import { renderIcons } from './utils/icons';
import { logDebug } from './utils/debug';

async function loadContent() {
    const loader = document.getElementById('hero-loading');
    if (loader) loader.textContent = 'Laster innhold…';

    try {
        const data = await fetchContentJson();
        if (!data) throw new Error('No data returned');

        logDebug('Content JSON loaded successfully');

        buildHero(data.hero);
        buildAbout(data.about);
        buildExperience(data.experience);
        buildEducation(data.education);
        buildCertifications(data.certifications);
        buildSkills(data.skills);
        buildProjects(data.projects);
        buildContact(data.contact);
        buildFooter(data.footer);

        renderIcons();
        scheduleIntegrityCheck();

        const skillCount = data.skills?.items?.length || 0;
        const projectCount = data.projects?.items?.length || 0;
        logDebug(`Stats -> skills:${skillCount} projects:${projectCount}`);

    } catch (e) {
        logDebug('Content Load Error occurred');
        if (loader) loader.textContent = 'Kunne ikke laste innholdet. Prøv å laste siden på nytt.';
    }
}

function scheduleIntegrityCheck() {
    setTimeout(() => {
        try {
            const data = getContent();
            if (!data) return;

            const skillsGrid = document.querySelector('[data-section="skills"] .grid');
            const projectGrid = document.querySelector('[data-section="projects"] .grid');

            if (skillsGrid && skillsGrid.children.length === 0 && data.skills?.items?.length) {
                logDebug('Integrity: skills empty – re-rendering');
                buildSkills(data.skills);
                renderIcons();
            }
            if (projectGrid && projectGrid.children.length === 0 && data.projects?.items?.length) {
                logDebug('Integrity: projects empty – re-rendering');
                buildProjects(data.projects);
                renderIcons();
            }
        } catch (e) {
            logDebug('Integrity check error ' + (e instanceof Error ? e.message : String(e)));
        }
    }, 1200);
}

(function init() {
    // Init Navigation (listeners) + static header/scroll-top icons
    initNavigation();
    renderIcons();

    // Load content
    loadContent();

    // Hero timeout check
    setTimeout(() => {
        const hero = document.querySelector('[data-section="hero"]');
        if (hero && hero.textContent && hero.textContent.match(/Laster/)) {
            const overlay = document.getElementById('debug-overlay');
            if (overlay) overlay.classList.remove('hidden');
            logDebug('Timeout: hero still loading after 2s.');
        }
    }, 2000);

    // Debug overlay logic
    const debugClose = document.getElementById('debug-close');
    const debugOverlay = document.getElementById('debug-overlay');
    if (debugClose && debugOverlay) {
        debugClose.addEventListener('click', () => {
            debugOverlay.classList.add('hidden');
        });
    }
})();
